import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../urls";
import { v1EventLinkToCurrent } from "./v1EventLinkToCurrent";

export const LegacyEventLinkRedirect = () => {
  const { eventId } = useParams();
  const location = useLocation();

  if (!eventId) return <Navigate to={urls.app.sourcingEvents.viewAll} replace />;

  return <Navigate to={v1EventLinkToCurrent(eventId, location.search)} replace />;
};
